import React from "react";
import { Helmet } from "react-helmet-async";

import ContactHero from "../components/contact/ContactHero";
import GlobalCta from "../components/global/GlobalCta";
import FujairahTextImage from "../components/truck-rental-fujairah/FujairahTextImage";
import FujairahTextSection from "../components/truck-rental-fujairah/FujairahTextSection";
import FujairahFaq from "../components/truck-rental-fujairah/FujairahFaq";
import VanRentalTable from "../components/van-rental-dubai/VanRentalTable";
import ChillerVanWhyChoose from "../components/chiller-van/ChillerVanWhyChoose";

import { chillerVanAbuDhabiSections } from "../components/chiller-van-abu-dhabi/chillerVanAbuDhabiSections";
import "../components/truck-rental-fujairah/truck-rental-fujairah.css";
import "../components/van-rental-dubai/van-rental-dubai.css";
import "../components/chiller-van/chiller-van.css";

const ChillerVanForRentInAbuDhabi = () => {
  const renderSection = (section, index) => {
    switch (section.type) {
      case "cva-hero":
        return (
          <ContactHero
            key={index}
            variant="chiller-van"
            title={section.title}
            paragraphs={section.paragraphs}
          />
        );

      case "cva-text-image":
        return (
          <FujairahTextImage
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
            image={section.image}
            imageAlt={section.imageAlt}
            reverse={section.reverse}
            altBg={section.altBg}
          />
        );

      case "cva-text-only":
        return (
          <FujairahTextSection
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
          />
        );

      case "cva-table":
        return (
          <VanRentalTable
            key={index}
            title={section.title}
            description={section.description}
            columns={section.columns}
            rows={section.rows}
            notes={section.notes}
            background={section.background}
          />
        );

      case "cva-industries":
        return (
          <ChillerVanWhyChoose
            key={index}
            title={section.title}
            description={section.description}
            reasons={section.industries}
          />
        );

      case "cva-faq":
        return (
          <FujairahFaq
            key={index}
            title={section.title}
            faqs={section.faqs}
          />
        );

      case "cta":
        return (
          <GlobalCta
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
          />
        );

      default:
        return null;
    }
  };

  return (
    <>
      <Helmet>
        <title>Chiller Van for Rent in Abu Dhabi | From AED 300/Day</title>
        <meta name="description" content="Chiller van rental in Abu Dhabi from AED 300/day — 0°C to 8°C vans for Mussafah, ICAD, KIZAD and Al Ain distribution. 24 vans on local dispatch. Book Now" />
        <link rel="canonical" href="https://chillerfleet.com/chiller-van-for-rent-in-abu-dhabi" />
        <meta property="og:title" content="Chiller Van for Rent in Abu Dhabi | From AED 300/Day" />
        <meta property="og:description" content="Chiller van rental in Abu Dhabi from AED 300/day — 0°C to 8°C vans for Mussafah, ICAD, KIZAD and Al Ain distribution. 24 vans on local dispatch. Book Now" />
        <meta property="og:url" content="https://chillerfleet.com/chiller-van-for-rent-in-abu-dhabi" />
        <meta name="twitter:title" content="Chiller Van for Rent in Abu Dhabi | From AED 300/Day" />
        <meta name="twitter:description" content="Chiller van rental in Abu Dhabi from AED 300/day — 0°C to 8°C vans for Mussafah, ICAD, KIZAD and Al Ain distribution. 24 vans on local dispatch. Book Now" />
      </Helmet>

      {chillerVanAbuDhabiSections.map(renderSection)}
    </>
  );
};

export default ChillerVanForRentInAbuDhabi;
